<template>
  <footer class="footer">
    <b-container class="justify-content-center">
      <b-row class="justify-content-center">
        <h4>Follow Us</h4>
      </b-row>
      <b-row class="justify-content-center">
        <div class="social">
          <a
            href="https://twitter.com/colorsjapan1"
            class="twitter"
            title="Colors Japan on Twitter"
          ><b-icon icon="twitter" /></a>
          <a
            href="https://www.instagram.com/colors.japan"
            class="instagram"
            data-toggle="tooltip"
            data-placement="top"
            title="Colors Japan on Instagram"
          ><b-icon icon="instagram" /></a>
        </div>
      </b-row>
      <b-row class="footer-links">
        <b-col
          cols="12"
          sm="auto"
          class="text-center"
        >
          <router-link :to="{ name: 'events' }">
            Events
          </router-link>
        </b-col>
        <b-col
          cols="12"
          sm="auto"
          class="text-center"
        >
          <router-link :to="{ name: 'communities' }">
            Communities
          </router-link>
        </b-col>
        <b-col
          cols="12"
          sm="auto"
          class="text-center"
        >
          <router-link :to="{ name: 'privacy-policy' }">
            プライバシーポリシー
          </router-link>
        </b-col>
        <b-col
          cols="12"
          sm="auto"
          class="text-center"
        >
          <router-link :to="{ name: 'eula' }">
            利用規約
          </router-link>
        </b-col>
        <b-col
          cols="12"
          sm="auto"
          class="text-center"
        >
          <b-link
            :href="`${colorsWebUrl}/about`"
            target="_blank"
          >
            About
          </b-link>
        </b-col>
        <b-col
          cols="12"
          sm="auto"
          class="text-center"
        >
          <b-link
            :href="`${colorsWebUrl}/contact`"
            target="_blank"
          >
            Contact us
          </b-link>
        </b-col>
      </b-row>
      <b-row class="justify-content-center mt-3">
        <img
          src="/assets/img/logo-horizontal.png"
          alt="ColorsJP logo"
          width="200"
        >
      </b-row>
      <b-row class="justify-content-center">
        <p class="footer-text">
          会社情報 <br>
          株式会社yamaneco <br>
          〒150-0043 東京都渋谷区道玄坂2-10-7 新大宗ビル2号館 1107
        </p>
      </b-row>
    </b-container>
  </footer>
</template>

<style lang="less" scoped>
.footer {
  background: #f2f4f5;
  flex-direction: column;
  align-content: center;
  margin-top: 3rem;
  padding: 2rem 0;
  position: absolute;
  width: 100%;
  height: 300px;
  bottom: 0;
}

.social {
  a {
    font-size: 1.5rem;
    color: #d5347a;
    margin: 0 1rem;
  }
}

.footer-links {
  margin-top: 1rem;
  font-size: 1rem;
  justify-content: center;
}

.footer .widget-title {
  text-align: center;
}
.footer-text {
  font-size: 0.85rem;
  margin: 1rem 0 0 0;
  text-align: center;
}
</style>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      colorsWebUrl: process.env.VUE_APP_COLORSJP_WEB_URL,
    }
  }
}
</script>
